<template>
  <div class="auth-change-phone">
    <el-form ref="changePhoneForm"
    v-loading="loading"
    :model="form"
    :rules="rules"
    label-position="left">
      <p>Below is the question you selected during registration, please provide the answer you gave during registration.</p>
      <el-form-item :label="userQuestion" :inline-message="true" prop="answer">
        <el-input
            v-model="form.answer"
            size="medium"
            placeholder="Please answer your security question"
        />
      </el-form-item>
      <el-form-item label="Your date of birth" :inline-message="true" prop="dob">
        <el-date-picker
          v-model="form.dob"
          type="date"
          placeholder="DATE OF BIRTH (DD/MM/YYYY)"
          format="dd/MM/yyyy"
          value-format="MM/dd/yyyy"
          size="medium">
        </el-date-picker>
      </el-form-item>
      <el-form-item label="Enter your new mobile number (we will send a code to this number when you press continue)." :inline-message="true" prop="phone" class="new-phone">
        <el-input
            v-model="form.phone"
            size="medium"
            placeholder="e.g. 0412345678"
        />
      </el-form-item>
      <span class="text-muted">Please note this will update your member record.</span>
    </el-form>
    <el-alert v-if="error" title="Authentication failed" type="error" :description="error" show-icon></el-alert>
    <div class="form-action">
      <el-button type="primary" class="btn-confirm" :disabled="loading" @click="submitForm('changePhoneForm')">Continue</el-button>
      <el-button type="text" @click="cancelLogIn">Cancel and return to login</el-button>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  data() {
    return {
      form: {
        dob: '',
        answer: '',
        phone: '',
        loading: false
      },
      rules: {
        dob: {
          required: true,
          message: "Date of birth is required",
          trigger: "blur"
        },
        answer: {
          required: true,
          message: "Security question answer is required",
          trigger: "blur"
        },
        phone: {
          required: true,
          message: "New phone number is required",
          trigger: "blur"
        }
      }
    }
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      loading: state => state.auth.loading,
      error: state => state.auth.error,
    }),
    userQuestion() {
      if(this.user) {
        return this.user.security_question;
      }
      
      return 'Question N/A'
    }
  },
  methods: {
    ...mapActions('auth', ['cancelLogIn', 'changePhone']),
    submitForm(formName) {
      this.$refs[formName].validate(async (valid) => {
        if (!valid) {
          return false;
        }
        await this.changePhone({
          "security_answer": this.form.answer,
          "dob": this.form.dob,
          "mobile": this.form.phone
        });
      });
    },
  }
}
</script>

<style lang="scss" scoped>
.auth-change-phone {
  p {
    font-size: 0.925rem;
    line-height: 24px;
    margin-top: 0;
  }

  .el-form {
    .text-muted {
      display: inline-block;
      color: #606266;
      font-size: 0.825rem;
      font-style: italic;
      margin-bottom: 10px;
    }

    .el-alert {
      margin-bottom: 15px;
    }

    .el-form-item {
      margin-bottom: 10px!important;

      &.new-phone {
        margin-bottom: 0px!important;
      }

      .el-date-editor {
        width: 100%;

        .el-input__prefix, .el-input__suffix {
          height: 77%;
        }
      }

      .el-form-item__label {
        line-height: 22px;
        font-weight: bold;
      }

      .el-form-item__content {
        .el-form-item__error {
          padding-top: 0;
          padding-bottom: 4px;
        }
      }
    }
  }

  .form-action {
    .btn-confirm {
      margin-top: 18px;
      font-weight: bold;
      font-size: 0.945rem;
      width: 100%;
      padding-top: 18px;
      padding-bottom: 18px;
    }

    .el-button--text {
      margin-left: 0;
      color: #67C23A;
      padding-top: 6px;
      padding-bottom: 0;

      &:hover {
        font-weight: bold;
      }
    }
  }
}
</style>
